import React, { useEffect, createContext, useContext, useState, useMemo } from 'react'

const DeviceWidthContext = createContext()

function useDeviceWidth() {
  const context = useContext(DeviceWidthContext)
  if (!context) {
    throw new Error('useDeviceWidth() must be used within the DeviceWidthProvider')
  }
  return context
}

function DeviceWidthProvider(props) {
  const [width, setWidth] = useState(0)

  useEffect(() => {
    function getWidth() {
      setWidth(window.innerWidth)
    }

    getWidth()
    window.addEventListener('resize', getWidth)

    return () => {
      window.removeEventListener('resize', getWidth)
    }
  })

  const value = useMemo(() => [width, setWidth], [width])
  return <DeviceWidthContext.Provider value={value} {...props} />
}

export { useDeviceWidth, DeviceWidthProvider }
